// frontend/src/pages/AcessoBloqueadoPage/AcessoBloqueadoPage.jsx
// Fase 3: Tela exibida quando o usuário está logado mas não tem acesso (trial expirado ou sem plano).

import React, { useEffect } from 'react';
import { Button, Card, Result, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logo from '../../assets/images/logo_vertical.jpg';
import '../../styles/auth.css';

const AcessoBloqueadoPage = () => {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated, acessoPermitido } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      navigate('/login', { replace: true });
      return;
    }
    // Convidado entra no espaço do titular (o ProtectedRoute faz a troca).
    if (acessoPermitido || user.workspace_convidado) {
      navigate('/meu-desempenho', { replace: true });
      return;
    }
    if (user.convite_pendente_token) {
      navigate(`/convite/${user.convite_pendente_token}`, { replace: true });
      return;
    }
    // Quem não teve trial não deve ver "Seu período acabou"; vai para contratação.
    if (!user.teve_trial) {
      navigate('/checkout', { replace: true });
    }
  }, [isAuthenticated, user, acessoPermitido, navigate]);

  if (!user || acessoPermitido || !user.teve_trial
      || user.workspace_convidado || user.convite_pendente_token) {
    return null;
  }

  const handleAssinar = () => {
    // Fase 4: substituir pela página real de checkout (plano + ciclo + pagamento).
    navigate('/checkout');
  };

  const handleSair = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="auth-shell">
      <Card className="auth-card auth-card--wide">
        <Image
          width={180}
          src={logo}
          alt="Logo Saldo Ativo"
          preview={false}
          className="auth-logo"
        />
        <Result
          status="warning"
          title="Seu teste grátis terminou"
          subTitle={
            <span style={{ color: 'var(--color-text-secondary)' }}>
              Seus dados continuam salvos. Para voltar a usar o Saldo Ativo, assine um
              de nossos planos — só Finanças, só Milhas ou o Completo. Tudo o que você
              cadastrou estará lá quando você voltar.
            </span>
          }
          extra={[
            <Button
              type="primary"
              key="assinar"
              size="large"
              block
              onClick={handleAssinar}
              style={{ marginBottom: 8 }}
            >
              Assinar agora
            </Button>,
            <Button key="sair" size="large" block onClick={handleSair}>
              Sair e usar outra conta
            </Button>,
          ]}
          style={{ padding: '0 0 24px 0' }}
        />
      </Card>
    </div>
  );
};

export default AcessoBloqueadoPage;
